module.exports = global["ES6Promise"] = require("-!/home/circleci/repo/node_modules/babel-loader/lib/index.js??ref--5!./es6-promise.min.js");